// BeatTrackView.js â€” the row of directional notes above the board (between
// Score and Steps). Shows the sequence of moves to walk the current line's
// path; the next move is highlighted and pulses in sync with the beat.

// Resolve asset URLs the Parcel way. A plain `import x from './a.png'` returns
// an object here (not a string), which stringifies to "[object Object]" on
// img.src â€” so use new URL(..., import.meta.url), which yields a real URL.
const ICON = {
    up: new URL("../assets/notes/notes_up.png", import.meta.url).href,
    down: new URL("../assets/notes/notes_down.png", import.meta.url).href,
    left: new URL("../assets/notes/notes_left.png", import.meta.url).href,
    right: new URL("../assets/notes/notes_right.png", import.meta.url).href,
};

export class BeatTrackView {
    constructor(rootEl) {
        this._root = rootEl;
        this._row = document.createElement("div");
        this._row.className = "beat-track__row";
        this._root.appendChild(this._row);

        this._renderedLine = -1;
        this._notes = [];
        this._currentEl = null;
        this._playing = null;
    }

    // Green pill while the song plays; white before start / paused / finished.
    setPlaying(playing) {
        if (playing === this._playing) return;
        this._playing = playing;
        this._root.classList.toggle("is-playing", playing);
    }

    render(state) {
        // Rebuild note icons only when the line changes.
        if (state.lineIndex !== this._renderedLine) {
            this._renderedLine = state.lineIndex;
            this._notes = state.moves.map((dir) => {
                const img = document.createElement("img");
                img.className = "note";
                img.src = ICON[dir];
                img.alt = dir;
                return img;
            });
            this._row.replaceChildren(...this._notes);
        }

        // Next move = the step from the current path position to the next bar.
        const cur = state.pathIndex;
        this._currentEl = null;
        for (let i = 0; i < this._notes.length; i++) {
            const note = this._notes[i];
            const isCurrent = i === cur;
            note.classList.toggle("note--done", i < cur);
            note.classList.toggle("note--current", isCurrent);
            note.classList.toggle("note--upcoming", i > cur);
            if (isCurrent) {
                this._currentEl = note;
            } else {
                // Clear any leftover pulse scale, otherwise a scrolled-off note
                // grows from its center and pokes a sliver back into view.
                note.style.transform = "";
            }
        }

        // Scroll the row so the current note sits at the start (done ones slide
        // off to the left), keeping the upcoming sequence in view. When every
        // note is done, over-scroll one extra step so nothing lingers at the edge.
        const allDone = cur >= this._notes.length;
        const scroll = allDone ? cur + 1 : cur;
        this._row.style.setProperty("--cur", Math.max(0, scroll));
    }

    // Called every frame with the current beat progress [0,1]. The active note
    // pops on the beat onset and relaxes toward the next beat.
    pulse(beatProgress) {
        if (!this._currentEl) return;
        const p = beatProgress == null ? 0 : beatProgress;
        const scale = 1 + 0.22 * (1 - p);
        this._currentEl.style.transform = `scale(${scale.toFixed(3)})`;
    }
}
